import { Box, CircularProgress, Typography } from "@mui/material"

import React from "react"

type IProps = {
  icon: React.JSX.Element
  backgroundColor: string
  color: string
  value: string | undefined
}

export function ModuleProjectBadge({ icon, backgroundColor, color, value }: Readonly<IProps>): React.JSX.Element {
  return (
    <Box display="flex" alignItems="center" p={1} px={3} gap={1} borderRadius={3} sx={{ background: backgroundColor }}>
      {icon}
      {value ? (
        <Typography variant="body1" sx={{ color }}>
          {value}
        </Typography>
      ) : (
        <CircularProgress size={16} />
      )}
    </Box>
  )
}
